import { AppState, AppStateStatus } from 'react-native';
import { isWeb } from '@helpers';

type VisibilityCallback = (isVisible: boolean) => void;

let visible = true;
const listeners = new Set<VisibilityCallback>();

const notify = (newVisible: boolean): void => {
  if (visible === newVisible) return;
  visible = newVisible;
  listeners.forEach((cb) => cb(visible));
};

// Initialize platform-specific listener (runs once at module load)
if (isWeb) {
  window.document.addEventListener('visibilitychange', () => {
    notify(!window.document.hidden);
  });
} else {
  // React Native >= 0.65 returns a subscription; we don't need to remove it since this is a true singleton
  AppState.addEventListener('change', (state: AppStateStatus) => {
    notify(state === 'active');
  });
}

export const appVisibilityService = {
  subscribe: (cb: VisibilityCallback): (() => void) => {
    listeners.add(cb);
    return () => {
      listeners.delete(cb);
    };
  },
  isVisible: (): boolean => visible,
};
